import Box from 'grommet/components/Box';
import CheckBox from 'grommet/components/CheckBox';
import Button from 'grommet/components/Button';
import Select from 'grommet/components/Select';
import React from 'react';
import Label from 'grommet/components/Label';
import TableSample from "./tablesample.js"
import Form from 'grommet/components/Form';
import FormFields from 'grommet/components/FormFields';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';

import { smallSize } from 'grommet/utils/Responsive';
import Tabletop from "./Tabletop.js"
import Spinning from 'grommet/components/icons/Spinning';


const publicSpreadsheetUrl = 'https://docs.google.com/spreadsheets/d/1a_kqOPncDyMm-Lrw0FsmRNLgfk0a0j7SW7A4VgQtax0/edit?usp=sharing';

/* function init() {
    Tabletop.init( { key: publicSpreadsheetUrl,
                     callback: showInfo,
                     simpleSheet: true } )
  }

function showInfo(data, tabletop) {
    console.log('Successfully processed!')
    console.log(data);
    const keys = Object.keys(data[0])
    const lengthKeys = keys.length;
    console.log(keys)
    const Arrayarray = []
    for (let i = 0; i < lengthKeys; i++) {
        let tempArray = []
        data.forEach((ele, index)=>{
            tempArray.push(ele[keys[i]])
        })
        Arrayarray.push(tempArray)
    }
    console.log(Arrayarray)
    
} */

//window.addEventListener('DOMContentLoaded', init)

//console.log(Tabletop.toArray())

const color = ["rgb(83,194,205)","rgb(157,87,4)","rgb(91,100,114)","rgb(86,130,216)","rgb(188,98,218)","rgb(196,175,84)","rgb(60,66,173)","rgb(226,160,160)","rgb(175,153,239)"]


class UrlData extends React.Component {
    constructor() {
        super();
        window.addEventListener('DOMContentLoaded', this.googleSheets)
        this._onClick = this._onClick.bind(this);
        this._onClickUrl = this._onClickUrl.bind(this);
        this._onChangeUrl = this._onChangeUrl.bind(this);
        this._onChangeNames = this._onChangeNames.bind(this)
        this.state = { 
            dataNames: [],
            url: null,
            urlPredict: null,
            resultReady: false,
            jsonoutput: [],
            jsonoutputTest: [],
            splitData: "80%-20%",
            currentValue: [],
            rows: 0,
            spinningFlag: false,
            enable: false
        }
    }
    componentDidMount() {
        
    }
    _onChange(event) {
        this.setState({currentValue: event.value})
    }
    _onClick(dataJsonParsed, jsonoutputTest, dataNames) {
        const {splitData, rows, urlPredict} = this.state;

        let dataNamesObj = {}
        dataNames.forEach((ele, index)=>{
            dataNamesObj[`positionname${index + 1}`] = ele
        })
        this.props.onSubmit(dataJsonParsed, splitData, rows, jsonoutputTest, urlPredict, dataNamesObj)
    }
    _onChangeNames(names) {
        this.setState({datanames: names})
    }

    
    _onClickUrl(url, urlPredict) {
        this.setState({spinningFlag: true})
        if (this.state.currentValue[0] === "Google Sheets") {
            this.googleSheets(url, urlPredict)
        } else {
            //Fetching 
            let jsonoutput = []
            //this.setState({spinIcon: true})
            if (url) {
                fetch(url).then((response) => {
                    return response.json(); 
                }).then((json) => { 
                    jsonoutput = json;
                    this.setState({resultReady: true, jsonoutput, spinningFlag: false}) 
                }).catch((err) => { 
                    console.log('Fetch problem: ' + err.message);
                    this.setState({resultReady: false, spinningFlag: false}) 
                }); 
            }
        }   
    }
    googleSheets(url, urlPredict) {
    //Add promises. See issues for sample of this library. Then set State wait for last call to remove spinners
        this.queryGoogle(url, "train")
        this.queryGoogle(urlPredict, "test")
    }
    queryGoogle(url, type) {
        const that = this;
        Tabletop.init({ key: url, //publicSpreadsheetUrl,
            callback: showInfo,
            simpleSheet: true,
            parseNumbers: true
        })
        let Arrayarray = [];
        function showInfo(data, tabletop) {
            //console.log(data)

            console.log(data)
            console.log('Successfully processed!')
            const rows = data.length;
            const keys = Object.keys(data[0])
            const lengthKeys = keys.length;
             
            for (let i = 0; i < lengthKeys; i++) {
                let tempArray = []
                data.forEach((ele, index)=>{
                    tempArray.push(ele[keys[i]])
                })
                Arrayarray.push(tempArray)
            }
            if (type === "train") {
                that.setState({resultReady: true, jsonoutput: Arrayarray, rows, spinningFlag: false, dataNames: keys})
            } else {
                //that.setState({resultReady: true, jsonoutputTest: Arrayarray, spinningFlag: false})
                that.setState({jsonoutputTest: Arrayarray})
            }  
        }
        this.setState({resultReady: false})
    }
    _onChangeUrl(event) {
        this.setState({url: event.target.value, enable: true})
    }
    _onChangeurlPredict(event) {
        this.setState({urlPredict: event.target.value})
    }
    _onChangeSplit(field) {
        this.setState({splitData: field.value})
    }
    componentWillUnmount() {
        window.removeEventListener('DOMContentLoaded', this.googleSheets)
    }
    render() {
        console.log("url render")
       const {url, urlPredict, resultReady, dataNames, jsonoutput, jsonoutputTest, splitData, currentValue, spinningFlag, enable} = this.state;
       let titleData, spinningComponent;
       console.log(jsonoutput)
       if (this.props.currentElement === "Anomaly Analysis GPU") {
        //numberOfRows = 8;
        titleData = "Type: Array<object: {date: string, value: number}>"
        
    } else {
        //numberOfRows = 2;
        titleData = "Type: Array<Array>"   
    }
       
        let content = <div>
                        
                            <Box direction='row'
                                    justify='start'
                                    align='left'
                                    wrap={true}
                                    reverse={false}
                                    margin='none'>
                                    <Box direction='row'
                                        align='left'
                                        wrap={true}
                                        pad='small'
                                        margin='none'
                                        style={{width: "20%"}}>
                                        <Label>Enter URL (Array[Array]):</Label>
                                        </Box>
                                    <Box direction='row'
                                        align='left'
                                        wrap={true}
                                        pad='small'
                                        margin='none'
                                        style={{width: "80%"}}>
                                        <input style={{padding: "0px 24px", width: "100%"}} placeholder="Google sheets URL or API returning multidimensional array type [[1,2,..],[3,4,...]]" onChange={this._onChangeUrl.bind(this)}></input><br/>
                                    </Box>
                                    {/* <Box direction='row'
                                        align='left'
                                        wrap={true}
                                        pad='small'
                                        margin='none'
                                        style={{width: "20%"}}>
                                        <Label>URL Predict:</Label>
                                        </Box>
                                    <Box direction='row'
                                        align='left'
                                        wrap={true}
                                        pad='small'
                                        margin='none'
                                        style={{width: "80%"}}>
                                        <input style={{padding: "0px 24px", width: "100%"}} placeholder="https://url.to.api see Home -> use cases to easily create url using google sheets" onChange={this._onChangeurlPredict.bind(this)}></input><br/>
                                    </Box>
                                    <Box direction='row'
                                        align='center'
                                        wrap={true}
                                        pad='medium'
                                        margin='none'>
                                        Split (%) Train vs Test &nbsp; &nbsp;
                                        <Select placeHolder='None'
                                            options={['80%-20%']}
                                            placeHolder={"Type"}
                                            value={splitData}
                                            onChange={this._onChangeSplit.bind(this)} />
                                    </Box>   */}         
                </Box>
            
            </div>
        if (spinningFlag) {
            spinningComponent = <div style={{position: "fixed", backgroundColor: "white", top: "0px", 
            bottom: "0px", right: "0px", left: "0px", opacity: "0.5", paddingTop: "30%",
            zIndex: "500", textAlign: "center"}}>
                <Label>Loading...</Label>
                <Spinning size={"huge"}/>
            </div>
        } else {
            spinningComponent = <div></div>
        }
        let contentButton = {}
        if (url) { 
            contentButton = {href: "#urltable", type: "submit", onClick: this._onClickUrl.bind(this, url, urlPredict)}
        } else {
            contentButton = {href: "", type: "", onClick: ""}
        }
        return (
            <div>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        <Button 
                            href={contentButton.href}
                            label='Visualize'
                            type={contentButton.type}
                            primary={true}
                            onClick={contentButton.onClick} 
                        />
                    </Box>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                    {resultReady && <Button 
                        label='Validate Types/Format'
                        type='submit'
                        primary={true}
                        onClick={this._onClick.bind(this, jsonoutput, jsonoutputTest, dataNames)} 
                    />
                    }
                    </Box>
                </div>
                <hr style={{width: "100%"}} />
                {spinningComponent}
                <div style={{position: "initial", paddingLeft: "2%"}}>
                    <Select 
                        inline={true}
                        multiple={true}
                        options={["Google Sheets"]}
                        value={currentValue}
                        onChange={this._onChange.bind(this)} 
                    />
                </div>
                
            {content}

            <div id={"urltable"}>Results (First 1000 rows):</div>
            {resultReady && jsonoutput[0] && <div><TableSample iterator={jsonoutput} dataNames={dataNames}/></div>}
         
            </div>
        );
    }
}

export default UrlData;
/* 
<textarea 
                                    rows={7} 
                                    style={{width: "100%"}}
                                    defaultValue={JSON.stringify(jsonoutput)}
                                    >
                                </textarea> */


// WEBPACK FOOTER //
// ./src/samples/data/url.js